/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc
 */

export let ComHubspotAutomationTemplatesCoreApiEnums;
(function (_ComHubspotAutomationTemplatesCoreApiEnums) {})(ComHubspotAutomationTemplatesCoreApiEnums || (ComHubspotAutomationTemplatesCoreApiEnums = {}));
export const ActionDataIdentifierTypename = 'com.hubspot.automationplatform.field.core.ActionDataIdentifier';
export const ActionDataIdentifierDiscriminant = 'ACTION';
export const ActionDataIdentifierDiscriminantKey = 'type';
export const EnrollmentDataIdentifierTypename = 'com.hubspot.automationplatform.field.core.EnrollmentDataIdentifier';
export const EnrollmentDataIdentifierDiscriminant = 'ENROLLMENT';
export const EnrollmentDataIdentifierDiscriminantKey = 'type';
export const FieldDataIdentifierDiscriminantKey = 'type';
export let ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF;
(function (_ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF) {})(ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF || (ComHubspotAutomationplatformFieldCoreTimeDelayTimeZoneStrategyIF = {}));
export const ArrayFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.ArrayFieldSchema';
export const ArrayFieldSchemaDiscriminant = 'ARRAY';
export const ArrayFieldSchemaDiscriminantKey = 'type';
export const BooleanFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.BooleanFieldSchema';
export const BooleanFieldSchemaDiscriminant = 'BOOLEAN';
export const BooleanFieldSchemaDiscriminantKey = 'type';
export const DoubleFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.DoubleFieldSchema';
export const DoubleFieldSchemaDiscriminant = 'DOUBLE';
export const DoubleFieldSchemaDiscriminantKey = 'type';
export const FieldSchemaDiscriminantKey = 'type';
export const IntegerFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.IntegerFieldSchema';
export const IntegerFieldSchemaDiscriminant = 'INTEGER';
export const IntegerFieldSchemaDiscriminantKey = 'type';
export const LongFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.LongFieldSchema';
export const LongFieldSchemaDiscriminant = 'LONG';
export const LongFieldSchemaDiscriminantKey = 'type';
export const ObjectFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.ObjectFieldSchema';
export const ObjectFieldSchemaDiscriminant = 'OBJECT';
export const ObjectFieldSchemaDiscriminantKey = 'type';
export const StringFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.StringFieldSchema';
export const StringFieldSchemaDiscriminant = 'STRING';
export const StringFieldSchemaDiscriminantKey = 'type';
export const UnknownFieldSchemaTypename = 'com.hubspot.automationplatform.field.core.definition.schema.UnknownFieldSchema';
export const UnknownFieldSchemaDiscriminant = 'UNKNOWN';
export const UnknownFieldSchemaDiscriminantKey = 'type';
export const ActionOutputObjectPropertyValueTypename = 'com.hubspot.automationplatform.field.core.input.ActionOutputObjectPropertyValue';
export const ActionOutputObjectPropertyValueDiscriminant = 'ACTION_OUTPUT_OBJECT_PROPERTY';
export const ActionOutputObjectPropertyValueDiscriminantKey = 'type';
export const AppendObjectPropertyValueTypename = 'com.hubspot.automationplatform.field.core.input.AppendObjectPropertyValue';
export const AppendObjectPropertyValueDiscriminant = 'APPEND_OBJECT_PROPERTY';
export const AppendObjectPropertyValueDiscriminantKey = 'type';
export const EnrollmentDatasetColumnValueTypename = 'com.hubspot.automationplatform.field.core.input.EnrollmentDatasetColumnValue';
export const EnrollmentDatasetColumnValueDiscriminant = 'ENROLLMENT_DATASET_COLUMN';
export const EnrollmentDatasetColumnValueDiscriminantKey = 'type';
export const EnrollmentEventPropertyValueTypename = 'com.hubspot.automationplatform.field.core.input.EnrollmentEventPropertyValue';
export const EnrollmentEventPropertyValueDiscriminant = 'ENROLLMENT_EVENT_PROPERTY';
export const EnrollmentEventPropertyValueDiscriminantKey = 'type';
export const FetchedObjectPropertyValueTypename = 'com.hubspot.automationplatform.field.core.input.FetchedObjectPropertyValue';
export const FetchedObjectPropertyValueDiscriminant = 'FETCHED_OBJECT_PROPERTY';
export const FetchedObjectPropertyValueDiscriminantKey = 'type';
export const FieldDataValueTypename = 'com.hubspot.automationplatform.field.core.input.FieldDataValue';
export const FieldDataValueDiscriminant = 'FIELD_DATA';
export const FieldDataValueDiscriminantKey = 'type';
export const IncrementValueTypename = 'com.hubspot.automationplatform.field.core.input.IncrementValue';
export const IncrementValueDiscriminant = 'INCREMENT';
export const IncrementValueDiscriminantKey = 'type';
export const InputValueDiscriminantKey = 'type';
export const ListInputValueTypename = 'com.hubspot.automationplatform.field.core.input.ListInputValue';
export const ListInputValueDiscriminant = 'LIST_INPUT_VALUE';
export const ListInputValueDiscriminantKey = 'type';
export const MapInputValueTypename = 'com.hubspot.automationplatform.field.core.input.MapInputValue';
export const MapInputValueDiscriminant = 'MAP_INPUT_VALUE';
export const MapInputValueDiscriminantKey = 'type';
export const MultiValueTypename = 'com.hubspot.automationplatform.field.core.input.MultiValue';
export const MultiValueDiscriminant = 'MULTI_VALUE';
export const MultiValueDiscriminantKey = 'type';
export const ObjectCoordinatesProviderValueTypename = 'com.hubspot.automationplatform.field.core.input.ObjectCoordinatesProviderValue';
export const ObjectCoordinatesProviderValueDiscriminant = 'OBJECT_COORDINATES_PROVIDER';
export const ObjectCoordinatesProviderValueDiscriminantKey = 'type';
export const ObjectPropertyValueTypename = 'com.hubspot.automationplatform.field.core.input.ObjectPropertyValue';
export const ObjectPropertyValueDiscriminant = 'OBJECT_PROPERTY';
export const ObjectPropertyValueDiscriminantKey = 'type';
export const RelativeDateTimeValueTypename = 'com.hubspot.automationplatform.field.core.input.RelativeDateTimeValue';
export const RelativeDateTimeValueDiscriminant = 'RELATIVE_DATETIME';
export const RelativeDateTimeValueDiscriminantKey = 'type';
export const SingleObjectCoordinatesValueTypename = 'com.hubspot.automationplatform.field.core.input.SingleObjectCoordinatesValue';
export const SingleObjectCoordinatesValueDiscriminant = 'SINGLE_OBJECT_COORDINATES';
export const SingleObjectCoordinatesValueDiscriminantKey = 'type';
export const StaticAppendValueTypename = 'com.hubspot.automationplatform.field.core.input.StaticAppendValue';
export const StaticAppendValueDiscriminant = 'STATIC_APPEND_VALUE';
export const StaticAppendValueDiscriminantKey = 'type';
export const StaticValueTypename = 'com.hubspot.automationplatform.field.core.input.StaticValue';
export const StaticValueDiscriminant = 'STATIC_VALUE';
export const StaticValueDiscriminantKey = 'type';
export const TimestampValueTypename = 'com.hubspot.automationplatform.field.core.input.TimestampValue';
export const TimestampValueDiscriminant = 'TIMESTAMP';
export const TimestampValueDiscriminantKey = 'type';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const BooleanFieldValueDiscriminant = 'boolean';
export const BooleanFieldValueDiscriminantKey = '@type';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const DoubleFieldValueDiscriminant = 'double';
export const DoubleFieldValueDiscriminantKey = '@type';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const FloatFieldValueDiscriminant = 'float';
export const FloatFieldValueDiscriminantKey = '@type';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const IntFieldValueDiscriminant = 'integer';
export const IntFieldValueDiscriminantKey = '@type';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const ListFieldValueDiscriminant = 'list';
export const ListFieldValueDiscriminantKey = '@type';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const LongFieldValueDiscriminant = 'long';
export const LongFieldValueDiscriminantKey = '@type';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const MapFieldValueDiscriminant = 'map';
export const MapFieldValueDiscriminantKey = '@type';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const NullFieldValueDiscriminant = 'null';
export const NullFieldValueDiscriminantKey = '@type';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const StringFieldValueDiscriminant = 'string';
export const StringFieldValueDiscriminantKey = '@type';
export let ComHubspotChirpExtModels;
(function (_ComHubspotChirpExtModels) {
  const FieldValueDiscriminantKey = _ComHubspotChirpExtModels.FieldValueDiscriminantKey = '@type';
})(ComHubspotChirpExtModels || (ComHubspotChirpExtModels = {}));
export let ComHubspotContactsDataContactsProtos;
(function (_ComHubspotContactsDataContactsProtos) {})(ComHubspotContactsDataContactsProtos || (ComHubspotContactsDataContactsProtos = {}));
export const ActionTypeIconTypename = 'com.hubspot.marketplace.products.models.features.ActionTypeIcon';
export const ActionTypeIconDiscriminant = 'ACTION_TYPE';
export const ActionTypeIconDiscriminantKey = 'type';
export const AppIconTypename = 'com.hubspot.marketplace.products.models.features.AppIcon';
export const AppIconDiscriminant = 'APP';
export const AppIconDiscriminantKey = 'type';
export const AppObjectDataTypename = 'com.hubspot.marketplace.products.models.features.AppObjectData';
export const AppObjectDataDiscriminant = 'APP_OBJECT';
export const AppObjectDataDiscriminantKey = 'type';
export const ChirpRpcDataTypename = 'com.hubspot.marketplace.products.models.features.ChirpRpcData';
export const ChirpRpcDataDiscriminant = 'CHIRP_RPC';
export const ChirpRpcDataDiscriminantKey = 'type';
export const FeatureDataDiscriminantKey = 'type';
export const KnowledgeBoxDataTypename = 'com.hubspot.marketplace.products.models.features.KnowledgeBoxData';
export const KnowledgeBoxDataDiscriminant = 'KNOWLEDGE_BOX';
export const KnowledgeBoxDataDiscriminantKey = 'type';
export const McpServerDataTypename = 'com.hubspot.marketplace.products.models.features.McpServerData';
export const McpServerDataDiscriminant = 'MCP_SERVER';
export const McpServerDataDiscriminantKey = 'type';
export const OffPlatformAgentFeatureDataTypename = 'com.hubspot.marketplace.products.models.features.OffPlatformAgentFeatureData';
export const OffPlatformAgentFeatureDataDiscriminant = 'OFF_PLATFORM_AGENT_FEATURE';
export const OffPlatformAgentFeatureDataDiscriminantKey = 'type';
export const StudioAgentFeatureDataTypename = 'com.hubspot.marketplace.products.models.features.StudioAgentFeatureData';
export const StudioAgentFeatureDataDiscriminant = 'STUDIO_AGENT';
export const StudioAgentFeatureDataDiscriminantKey = 'type';
export const UIEDataTypename = 'com.hubspot.marketplace.products.models.features.UIEData';
export const UIEDataDiscriminant = 'UIE';
export const UIEDataDiscriminantKey = 'type';
export const WorkflowActionDataTypename = 'com.hubspot.marketplace.products.models.features.WorkflowActionData';
export const WorkflowActionDataDiscriminant = 'WORKFLOW_ACTION';
export const WorkflowActionDataDiscriminantKey = 'type';
export const WorkflowActionIconDiscriminantKey = 'type';
export const WorkflowTriggerDataTypename = 'com.hubspot.marketplace.products.models.features.WorkflowTriggerData';
export const WorkflowTriggerDataDiscriminant = 'WORKFLOW_TRIGGER';
export const WorkflowTriggerDataDiscriminantKey = 'type';
export let ComHubspotMarketplaceProductsModelsFeatures;
(function (_ComHubspotMarketplaceProductsModelsFeatures) {})(ComHubspotMarketplaceProductsModelsFeatures || (ComHubspotMarketplaceProductsModelsFeatures = {}));
export const AgentDataTypename = 'com.hubspot.marketplace.products.models.products.AgentData';
export const AgentDataDiscriminant = 'AGENT';
export const AgentDataDiscriminantKey = 'type';
export const AgentVersionDataTypename = 'com.hubspot.marketplace.products.models.products.AgentVersionData';
export const AgentVersionDataDiscriminant = 'AGENT';
export const AgentVersionDataDiscriminantKey = 'type';
export const AppDataTypename = 'com.hubspot.marketplace.products.models.products.AppData';
export const AppDataDiscriminant = 'APP';
export const AppDataDiscriminantKey = 'type';
export const AppVersionDataTypename = 'com.hubspot.marketplace.products.models.products.AppVersionData';
export const AppVersionDataDiscriminant = 'APP';
export const AppVersionDataDiscriminantKey = 'type';
export const ModuleDataTypename = 'com.hubspot.marketplace.products.models.products.ModuleData';
export const ModuleDataDiscriminant = 'MODULE';
export const ModuleDataDiscriminantKey = 'type';
export const ModuleVersionDataTypename = 'com.hubspot.marketplace.products.models.products.ModuleVersionData';
export const ModuleVersionDataDiscriminant = 'MODULE';
export const ModuleVersionDataDiscriminantKey = 'type';
export const ProductDataDiscriminantKey = 'type';
export const ProductVersionDataDiscriminantKey = 'type';
export const SolutionsPartnerProfileDataTypename = 'com.hubspot.marketplace.products.models.products.SolutionsPartnerProfileData';
export const SolutionsPartnerProfileDataDiscriminant = 'SOLUTIONS_PARTNER_PROFILE';
export const SolutionsPartnerProfileDataDiscriminantKey = 'type';
export const SolutionsPartnerProfileVersionDataTypename = 'com.hubspot.marketplace.products.models.products.SolutionsPartnerProfileVersionData';
export const SolutionsPartnerProfileVersionDataDiscriminant = 'SOLUTIONS_PARTNER_PROFILE';
export const SolutionsPartnerProfileVersionDataDiscriminantKey = 'type';
export const ThemeDataTypename = 'com.hubspot.marketplace.products.models.products.ThemeData';
export const ThemeDataDiscriminant = 'THEME';
export const ThemeDataDiscriminantKey = 'type';
export const ThemeVersionDataTypename = 'com.hubspot.marketplace.products.models.products.ThemeVersionData';
export const ThemeVersionDataDiscriminant = 'THEME';
export const ThemeVersionDataDiscriminantKey = 'type';
export const WorkflowTemplateDataTypename = 'com.hubspot.marketplace.products.models.products.WorkflowTemplateData';
export const WorkflowTemplateDataDiscriminant = 'WORKFLOW_TEMPLATE';
export const WorkflowTemplateDataDiscriminantKey = 'type';
export const WorkflowTemplateVersionDataTypename = 'com.hubspot.marketplace.products.models.products.WorkflowTemplateVersionData';
export const WorkflowTemplateVersionDataDiscriminant = 'WORKFLOW_TEMPLATE';
export const WorkflowTemplateVersionDataDiscriminantKey = 'type';
export let ComHubspotMarketplaceProductsModelsProducts;
(function (_ComHubspotMarketplaceProductsModelsProducts) {})(ComHubspotMarketplaceProductsModelsProducts || (ComHubspotMarketplaceProductsModelsProducts = {}));
export let ComHubspotMarketplaceProductsModelsProductsAgents;
(function (_ComHubspotMarketplaceProductsModelsProductsAgents) {})(ComHubspotMarketplaceProductsModelsProductsAgents || (ComHubspotMarketplaceProductsModelsProductsAgents = {}));
export let ComHubspotMarketplaceProductsModelsProductsJdk17;
(function (_ComHubspotMarketplaceProductsModelsProductsJdk) {})(ComHubspotMarketplaceProductsModelsProductsJdk17 || (ComHubspotMarketplaceProductsModelsProductsJdk17 = {}));
export const ArrayValueTypename = 'com.hubspot.marketplace.schemata.models.entries.ArrayValue';
export const ArrayValueDiscriminant = 'ARRAY';
export const ArrayValueDiscriminantKey = 'type';
export const ChoiceValueTypename = 'com.hubspot.marketplace.schemata.models.entries.ChoiceValue';
export const ChoiceValueDiscriminant = 'CHOICE';
export const ChoiceValueDiscriminantKey = 'type';
export const GroupValueTypename = 'com.hubspot.marketplace.schemata.models.entries.GroupValue';
export const GroupValueDiscriminant = 'GROUP';
export const GroupValueDiscriminantKey = 'type';
export const LocationValueTypename = 'com.hubspot.marketplace.schemata.models.entries.LocationValue';
export const LocationValueDiscriminant = 'LOCATION';
export const LocationValueDiscriminantKey = 'type';
export const LongValueTypename = 'com.hubspot.marketplace.schemata.models.entries.LongValue';
export const LongValueDiscriminant = 'LONG';
export const LongValueDiscriminantKey = 'type';
export const MediaValueTypename = 'com.hubspot.marketplace.schemata.models.entries.MediaValue';
export const MediaValueDiscriminant = 'MEDIA';
export const MediaValueDiscriminantKey = 'type';
export const StringValueTypename = 'com.hubspot.marketplace.schemata.models.entries.StringValue';
export const StringValueDiscriminant = 'STRING';
export const StringValueDiscriminantKey = 'type';
export let ComHubspotMarketplaceSchemataModelsEntries;
(function (_ComHubspotMarketplaceSchemataModelsEntries) {
  const FieldValueDiscriminantKey = _ComHubspotMarketplaceSchemataModelsEntries.FieldValueDiscriminantKey = 'type';
})(ComHubspotMarketplaceSchemataModelsEntries || (ComHubspotMarketplaceSchemataModelsEntries = {}));
export let ComHubspotUsagebasedbillingCommonsModels;
(function (_ComHubspotUsagebasedbillingCommonsModels) {})(ComHubspotUsagebasedbillingCommonsModels || (ComHubspotUsagebasedbillingCommonsModels = {}));
export const getDetailsRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getDetails',
  auth: 'internal',
  fingerprint: 'AAAAAAAAAADlU91DDCfm6Z-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getListingSummariesRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getListingSummaries',
  auth: 'internal',
  fingerprint: 'xySVIHl1J0B8Vj8yjHkeQJ-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDraftListingRpc = {
  serviceName: 'com.hubspot.marketplace.listing.details.rpc.MarketplaceListingEditorRpc',
  rpcName: 'getDraftListing',
  auth: 'internal',
  fingerprint: 'psOLGDKotUqjfkJwW1qLGp-gTPRevjAZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};